import { Entity } from '@core/entities/entity'
import { plainToInstance, Type } from 'class-transformer'
import { IInspectionStats } from './IInspectionStats'
import { TimeRangeProjectAnalytics } from '../TimeRangeProjectAnalytics'
import { InspectionStatsTasks } from './InspectionStatsTasks'

export class InspectionStats extends Entity<IInspectionStats> {
  @Type(() => TimeRangeProjectAnalytics)
  lastSevenDays: TimeRangeProjectAnalytics

  @Type(() => InspectionStatsTasks)
  tasks: InspectionStatsTasks

  public getResolvedOnTimePercentageRounded(): number {
    if (!this.tasks?.resolvedOnTimePercentage) {
      return 0
    }
    return Math.ceil(this.tasks.resolvedOnTimePercentage * 100) / 100
  }

  public static new(payload: unknown): InspectionStats {
    const entity = plainToInstance(InspectionStats, payload)

    return entity
  }
}
